import { Injectable } from '@angular/core';
// import { MatDialog } from '@angular/material';
import { AddModuleComponent } from 'src/app/project/add-module/add-module.component';
import { AddParentModuleComponent } from 'src/app/project/add-parent-module/add-parent-module.component';
import { AddSuiteModuleComponent } from 'src/app/project/add-suite-module/add-suite-module.component';
import { RenameComponent } from 'src/app/project/rename/rename.component';
import { ImportComponent } from 'src/app/project/import/import.component';
import { UpdateFormComponent } from '../test-case/update-form/update-form.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { StepFormComponent } from './step-form/step-form.component';
import { UpdateLocatorComponent } from 'src/app/project/locators/update-locator/update-locator.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { RecordDataComponent } from './record-data/record-data.component';
import { RecordTestCaseConfirmationComponent } from './record-test-case-confirmation/record-test-case-confirmation.component';

@Injectable()
export class ConfirmationDialogService {

  constructor(private dialog: MatDialog) { }

  openConfirmDialog(msg){
   return this.dialog.open(ConfirmationDialogComponent,{
      width: '390px',
      panelClass: 'confirm-dialog-container',
      disableClose: true,
      data :{
        message : msg
      }
    });
  }

  openFormPopUp(testCaseStepData){
    return this.dialog.open(UpdateFormComponent,{
      width: '630px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "10px"},
      data: {
        message: testCaseStepData,
        
      }
      
    })
  }

  openRenamePopUp(projectData){
    return this.dialog.open(RenameComponent,{
      width: '600px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "10px", left:"300px"},
      data: {
        message: projectData,
        
      }
      
    })
  }

  openAddModulePopUp(pathData){
    return this.dialog.open(AddModuleComponent,{
      width: '630px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "10px"},
      data: {
        message: pathData,
        
      }
      
    })
  }
  openParentModulePopUp(parentModule){
    return this.dialog.open(AddParentModuleComponent,{
      width: '520px',
      // panelClass: 'custom-modalbox',
      disableClose: true,
      position: { top: "60px"},
      data: {
        message: parentModule,
        
      }
      
    })
  }
  openAddtestSuitPopUp(item,status){
    return this.dialog.open(AddSuiteModuleComponent,{
      width: '630px',
      // height:'300px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "60px"},
      data: {
        message:item,
        status:status
        
      }
      
    })
  }
  
  openUpdatePopUp(item,moduleName,CheckCall? : string,buttonIdentifier? : string){
    return this.dialog.open(StepFormComponent,{
      width: '800px',
      id : "update-popup",
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "1px"},
      data: {
        message:item,
        moduleName:moduleName,
        CheckCall:CheckCall,
        buttonIdentifier:buttonIdentifier
      }
      
    })
  }


  openImportPopup(item){
    return this.dialog.open(ImportComponent,{
      width: '630px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "60px"},
      data: {
        message:item,
        
      }
      
    })
  }
  updateLocatorPopUp(locatorData,Index){
    return this.dialog.open(UpdateLocatorComponent,{
      width: '800px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: "10px", left:"300px"},
      data: {
        item:locatorData,
        index:Index
        
      }
      
    })
  }

  
  openRecordDialog(msg, tabList, mode?, opts?: { showMouseSequence?: boolean, projectType?: string }){
    return this.dialog.open(RecordDataComponent,{
       width: '390px',
       panelClass: 'confirm-dialog-container',
       disableClose: true,
       data :{
         message : msg,
         tabs: tabList,
         mode: mode,
         showMouseSequence: opts?.showMouseSequence !== false,
         projectType: opts?.projectType
       }
     });
   }

   stopRecordconfirmationDialog(msg){
    return this.dialog.open(RecordTestCaseConfirmationComponent,{
       width: '390px',
       panelClass: 'confirm-dialog-container',
       disableClose: true,
       data :{
         message : msg
       }
     });
   }
}
//